import moment from 'moment';

class TimeManipulation {
  static turnHour = turnTime => Number(turnTime.slice(0, 2));

  static hourDifferenceLessThan = (programmedTurnDate, now, hours) =>
    moment(programmedTurnDate, 'YYYYMMDDHHmm').diff(now, 'hours') < hours;

  static minutesDifference = (turnTime, today) => {
    let minuteDiff = Number(turnTime.slice(2, 4)) - today.getMinutes();
    if (minuteDiff < 0) {
      if (TimeManipulation.turnHour(turnTime) > today.getHours()) {
        // example: turn -> 12:15 y today 11:51
        minuteDiff = 60 - today.getMinutes() + Number(turnTime.slice(2, 4));
      } else {
        // if patient entered in the 10 minute tolerance of the turns time the diff is negative,
        // so that i reset the minuteDiff to zero
        // example: turn: 11:15 y today: 11:20
        minuteDiff = 0;
      }
    } else if (TimeManipulation.turnHour(turnTime) < today.getHours()) {
      // 10:50 (turn time) and 11:00 (today)
      minuteDiff = 0;
    }
    return minuteDiff;
  };

  static WaitingTime = turnTime => {
    const minuteDiff = TimeManipulation.minutesDifference(turnTime, new Date());
    let minutes;
    function range(init, end) {
      return init <= minuteDiff && minuteDiff < end;
    }
    const functions = {
      // turns are 15 minutes long.
      // always setting the lower value of the range to the waiting minutes
      time(init, end) {
        if (range(init, end)) {
          minutes = init;
        } else {
          this.time(init + 15, end + 15);
        }
      },
      getMinutes() {
        return minutes;
      },
    };
    return functions;
  };

  static changeAproxWaitingTime(aproxTimeDesc, aproxTimeInterval) {
    let arr = '';
    const rx = /(\d+) Minutos/g;
    arr = aproxTimeDesc.match(rx);
    let minutes = '';
    if (arr) {
      minutes = parseInt(arr[0], 10);
      if (minutes - 5 > 5) {
        return `Tiempo Aproximado De Atención: ${minutes - 5} Minutos`;
      }
    }
    clearInterval(aproxTimeInterval);
    return 'Debido a la alta demanda de este servicio el tiempo de espera puede ser prolongado, también puede comunicarse con nuestra línea de Orientación Médica Telefónica al 011 4363-4710. Por cualquier urgencia comuníquese al 0-800-777-7800';
  }
}

export default TimeManipulation;



// WEBPACK FOOTER //
// ./src/utils/timeManipulation.js